module.exports = __webpack_public_path__ + "static/media/ico-btn-teams.df7784ab.svg";